import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';

export const RemainingNumber = ({ value }) => {
  const { images } = useImagesContext();
  const imageTagList = [];
  for (let i = value.length - 1; i >= 0; i -= 1) {
    const charector = value[i];
    imageTagList.push(
      <NumberImage
        key={`remaining-${i}`}
        src={images[`remaining-${charector}.png`]}
        alt=""
      />,
    );
  }
  return (
    <Container>
      <Block>{imageTagList.reverse()}</Block>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  height: 100px;
  width: 200px;
  top: 317px;
  right: 0px;
`;

const Block = styled.div`
  display: flex;
  justify-content: center;
  transform: rotateY(45deg) skewY(6deg);
`;

const NumberImage = styled.img`
  height: 100px;
  position: relative;
`;
